export default __webpack_public_path__ + "static/media/donut.7b774f68.png";